import { render } from "./navbar.vue?vue&type=template&id=1874e6be&scoped=true"
import script from "./navbar.vue?vue&type=script&lang=js"
export * from "./navbar.vue?vue&type=script&lang=js"

import "./navbar.vue?vue&type=style&index=0&id=1874e6be&scoped=true&lang=css"
import "./navbar.vue?vue&type=style&index=1&id=1874e6be&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1874e6be"]])

export default __exports__